@if (isInit) {
  <mat-stepper #stepper class="stepper onboarding">
    @if (message && message.additional_data) {
      <mat-step>
        <div class="sc-dialog-wrapper">
          <div class="m3-dialog-header">
            <mat-icon class="m3-dialog-icon">waving_hand</mat-icon>
            <h2 class="m3-dialog-headline">
              {{ message.additional_data.general_welcome_title }}
            </h2>
          </div>
          <div mat-dialog-content>
            <div class="intro">
              <div
                [innerHTML]="message.additional_data.general_welcome_body"
              ></div>
              <video-player-module
                [videoData]="{
                  id: '',
                  video_type: 'vimeo',
                  video_title: 'Willkommen',
                  video_url: message.additional_data.general_welcome_video,
                }"
                class="my-6"
              ></video-player-module>
            </div>
          </div>
          <div mat-dialog-actions class="d-flex flex-justify-content-end">
            <button mat-button matStepperNext class="icon-end">
              {{ 'Next' | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </mat-step>
    }

    <mat-step>
      <div class="sc-dialog-wrapper">
        <div class="m3-dialog-header">
          <mat-icon class="m3-dialog-icon">person_check</mat-icon>
          <h2 class="m3-dialog-headline">
            {{ 'profile_confirmation_title' | translate }}
          </h2>
        </div>
        <div mat-dialog-content>
          <p class="text-muted mb-2 text-center">
            Bitte gib im untenstehende Formular die Daten desjenigen an, der den
            Kurs lernt und auf dessen Namen
            <strong style="font-weight: 600"
              >später der Fischereischein ausgestellt</strong
            >
            werden soll. Dies gilt auch für Minderjährige!
          </p>
          <form [formGroup]="form" class="pt-2">
            <div
              class="grid grid-align-items-start"
              style="row-gap: var(--md-sys-size-5)"
            >
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'first_name' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="first_name"
                  [required]="true"
                />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'last_name' | translate }}</mat-label>
                <input matInput formControlName="last_name" [required]="true" />
                <mat-hint>{{
                  'control_lower_and_uppercase' | translate
                }}</mat-hint>
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6">
                <mat-label>{{ 'birth_date' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="birthday"
                  [max]="maxDate"
                  [matDatepicker]="picker"
                  [required]="true"
                  (dateChange)="dateFormat($event)"
                />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
                <mat-hint class="text-muted">TT/MM/JJJJ</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'birthplace' | translate }}</mat-label>
                <input matInput formControlName="birthplace" />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-divider class="my-5"></mat-divider>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'email' | translate }}</mat-label>
                <input matInput formControlName="email" [required]="true" />
                <mat-error>
                  @if (
                    form.controls['email'].value != '' &&
                    form.controls['email'].value !=
                      form.controls['email_confirmation'].value
                  ) {
                    {{ 'email_mismatch' | translate }}
                  } @else {
                    {{ 'please_fill_in_this_required_field' | translate }}
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'email_confirmation' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="email_confirmation"
                  [required]="true"
                  (paste)="$event.preventDefault()"
                />
                <mat-error>
                  @if (
                    form.controls['email_confirmation'].value != '' &&
                    form.controls['email_confirmation'].value !=
                      form.controls['email'].value
                  ) {
                    {{ 'email_mismatch' | translate }}
                  } @else {
                    {{ 'please_fill_in_this_required_field' | translate }}
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'phone' | translate }}</mat-label>
                <input matInput formControlName="phone" />
              </mat-form-field>
              <mat-divider class="my-5"></mat-divider>
              <mat-form-field class="col-span-8" appearance="outline">
                <mat-label>{{ 'street' | translate }}</mat-label>
                <input matInput formControlName="street" [required]="true" />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="col-span-4" appearance="outline">
                <mat-label>{{ 'housenumber' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="housenumber"
                  [required]="true"
                />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-4" appearance="outline">
                <mat-label>{{ 'zip_code' | translate }}</mat-label>
                <input matInput formControlName="zip_code" [required]="true" />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-8" appearance="outline">
                <mat-label>{{ 'city' | translate }}</mat-label>
                <input matInput formControlName="city" [required]="true" />
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="sm-col-span-6" appearance="outline">
                <mat-label>{{ 'country' | translate }}</mat-label>
                <mat-select formControlName="country" [required]="true">
                  @for (country of countries; track country) {
                    <mat-option [value]="country">{{
                      country.country
                    }}</mat-option>
                  }
                </mat-select>
                <mat-error>
                  {{ 'please_fill_in_this_required_field' | translate }}
                </mat-error>
              </mat-form-field>
              <!-- <div class="col-span-8">
                  <label for="country">{{ 'country' | translate }}</label>
                  <select id="country" formControlName="country"></select>
                </div> -->
            </div>
          </form>
        </div>
        <div mat-dialog-actions class="d-flex flex-justify-content-between">
          <button mat-button matStepperPrevious>
            <mat-icon>arrow_back</mat-icon>
            {{ 'Back' | translate }}
          </button>
          <button mat-flat-button (click)="confirm($event)">
            <mat-icon>check</mat-icon>
            {{ 'Confirm' | translate }}
          </button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
}
